import React from 'react';
import illustration from '@/assets/noSearchResults.svg';
import { EmptyState } from '../EmptyState';

type Props = {
  searchTerm: string;
};

export const NoSearchResultsFoundEmptyState: React.FC<Props> = ({ searchTerm }) => (
  <EmptyState
    title="No search results found"
    description={`We couldn't find any flyers with "${searchTerm}". Try a different search term.`}
    illustration={illustration}
  />
);
